document.documentElement.classList.remove('no-js');

class ATMobileMenu extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-drawer]');
    this.openButton = document.querySelector('[data-menu-open]');
    this.closeButton = this.querySelector('[data-menu-close]');
    if (!this.drawer || !this.openButton) return;
    this.openButton.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('click', event => { if (event.target === this) this.close(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); });
  }
  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.body.classList.add('menu-open');
    this.openButton.setAttribute('aria-expanded', 'true');
  }
  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    this.openButton.setAttribute('aria-expanded', 'false');
    setTimeout(() => { this.hidden = true; }, 250);
  }
}
customElements.define('at-mobile-menu', ATMobileMenu);

class ATProduct extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-variant-select]');
    this.button = this.querySelector('[data-add-button]');
    this.price = this.querySelector('[data-product-price]');
    if (!this.select) return;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.select.addEventListener('change', () => this.update());
  }
  update() {
    const variant = this.variants.find(item => String(item.id) === this.select.value);
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    this.button.disabled = !variant.available;
    this.button.textContent = variant.available ? this.button.dataset.availableText : this.button.dataset.soldText;
    if (this.price) this.price.textContent = AT.formatMoney(variant.price);
  }
}
customElements.define('at-product', ATProduct);

const AT = {
  formatMoney(cents) {
    const format = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: format }).format(cents / 100);
  }
};

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('[data-reveal]').forEach(element => observer.observe(element));
} else {
  document.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
}
